export var ProbeErrorCode;
(function (ProbeErrorCode) {
    ProbeErrorCode["PROBE_ERROR_CODE_NETWORK_UNREACHABLE"] = "NetworkUnreachable";
    ProbeErrorCode["PROBE_ERROR_CODE_TIMEOUT"] = "Timeout";
    ProbeErrorCode["PROBE_ERROR_CODE_TLS_INVALID"] = "TLSInvalid";
    ProbeErrorCode["PROBE_ERROR_CODE_ACCESS_DENIED"] = "AccessDenied";
    ProbeErrorCode["PROBE_ERROR_CODE_AUTHENTICATION_FAILED"] = "AuthenticationFailed";
    ProbeErrorCode["PROBE_ERROR_CODE_INVALID_EXTERNAL_ID"] = "InvalidExternalId";
    ProbeErrorCode["PROBE_ERROR_CODE_INVALID_ARN"] = "InvalidArn";
    ProbeErrorCode["PROBE_ERROR_CODE_NOT_FOUND"] = "NotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_SECRET_NOT_FOUND"] = "SecretNotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_SECRET_SHAPE_INVALID"] = "SecretShapeInvalid";
    ProbeErrorCode["PROBE_ERROR_CODE_TOPIC_NOT_FOUND"] = "TopicNotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_SUBJECT_NOT_FOUND"] = "SubjectNotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_SCHEMA_NOT_FOUND"] = "SchemaNotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_CATALOG_NOT_FOUND"] = "CatalogNotFound";
    ProbeErrorCode["PROBE_ERROR_CODE_INVALID_SECURITY_CONFIG"] = "InvalidSecurityConfig";
    ProbeErrorCode["PROBE_ERROR_CODE_INVALID_REGEX"] = "InvalidRegex";
    ProbeErrorCode["PROBE_ERROR_CODE_UNSUPPORTED_FORMAT"] = "UnsupportedFormat";
    ProbeErrorCode["PROBE_ERROR_CODE_PARSE_FAILURE_RATE_TOO_HIGH"] = "ParseFailureRateTooHigh";
    ProbeErrorCode["PROBE_ERROR_CODE_TOPIC_EMPTY"] = "TopicEmpty";
})(ProbeErrorCode || (ProbeErrorCode = {}));
